import { render, staticRenderFns } from "./MenuEnrollment.vue?vue&type=template&id=4dcdbce9&"
import script from "./MenuEnrollment.vue?vue&type=script&lang=js&"
export * from "./MenuEnrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports